module.exports = __webpack_public_path__ + "static/media/csv.28fe5a30.svg";